// Retour sur une page (visite `restore` : retour arrière du navigateur, ou de
// l'app après une suppression depuis la fiche, cf. ProductsController) : Turbo
// la remet à sa position juste après le rendu. Mais sur une liste, la grille
// masque encore ses cartes en attendant leurs images et ne porte que sa
// première page : trop courte, la page bride la position vers le haut.
//
// On retient donc la position de chaque page en la quittant, et au retour on
// la réapplique au chargement puis à chaque mise en page de la grille. Chaque
// fois qu'elle bute sur le bas, la pagination infinie charge la page suivante,
// et ainsi de suite jusqu'à la position voulue. L'utilisateur reprend la main
// dès qu'il touche la page.
//
// Dans l'app, la position est retenue au tap (turbo:before-visit, avant que la
// visite ne passe côté natif) : quand turbo:visit arrive, l'écran suivant est déjà
// poussé, et s'il masque la barre d'onglets, la marge basse (--safe-area-bottom,
// posée par l'app) a déjà raccourci la page — en bas d'une liste, la position était
// bridée de la hauteur de la barre. Au retour, cette marge ne revient qu'après le
// rendu : la position est réappliquée dès que la page reprend de la hauteur.
// Un tap qui n'aboutit à aucune visite ici (visite annulée, modale native dans sa
// propre session) laisse cette position périmée : le moindre geste qui suit
// l'invalide, et la prochaine visite relève la position courante.
const positions = new Map()
let page = null
let pending = null
let wanted = null
let savedOnLeave = false

const apply = () => wanted && window.scrollTo(0, wanted)

document.addEventListener('turbo:before-visit', () => {
  if (!page) return

  positions.set(page, window.scrollY)
  savedOnLeave = true
})

// En attente jusqu'au chargement de la page : d'ici là, c'est encore la page
// qu'on quitte qui est affichée, et sa grille à elle qu'on ferait défiler.
document.addEventListener('turbo:visit', ({ detail: { url, action } }) => {
  // Visite lancée par l'app (retour, onglet) : pas de turbo:before-visit.
  if (page && !savedOnLeave) positions.set(page, window.scrollY)
  savedOnLeave = false
  const saved = action === 'restore' && positions.get(url)
  pending = saved > 0 ? saved : null
  wanted = null
})

// L'adresse lue au chargement, pas en partant : Turbo a déjà changé l'historique.
document.addEventListener('turbo:load', () => {
  page = location.href
  wanted = pending
  pending = null
  apply()
})

document.addEventListener('grid:rendered', apply)
// <html> reste en place d'une page à l'autre (Turbo ne remplace que le <body>).
new ResizeObserver(apply).observe(document.documentElement)

for (const name of ['pointerdown', 'touchstart', 'wheel', 'keydown']) {
  document.addEventListener(
    name,
    () => {
      wanted = null
      savedOnLeave = false
    },
    { passive: true }
  )
}
